import React, {Component} from 'react';
import { Modal } from 'react-bootstrap';
import Loader from 'react-loader-spinner';

class ModalCounter extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
		    show: false,
		    message:"",
		    count:0
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false});
	}

	repeatingFunc(cont, total) {
		cont++;
	    if(cont <= total){
	      	this.setState({count:cont});
	      	setTimeout(()=>{
	      		this.repeatingFunc(cont, total);
	      	}, 200);
	    }
  	}  

	handleShow(msg, total) {
		this.setState({ show: true,message:msg, total:total});

		this.repeatingFunc(this.state.count, total);

	}

	render(){
		return(
			<Modal show={this.state.show} bsSize="small"> 
        		<Modal.Header >
		        	<Modal.Title>{this.state.message}</Modal.Title>
		        </Modal.Header>
       			 <Modal.Body >
       			 <div style={{textAlign:'center', height:'100px'}}>
					<Loader 
					type="Oval" 
					color="#64b5f6" 
					height={80} 
					width={80}
					/> 
					<div className="col-xs-12">
						<h4>validandose {this.state.count+'/'+this.state.total}</h4>
					</div>
				</div>
		        </Modal.Body>
	      	</Modal>
		)
	}
}

export default ModalCounter;